export default __webpack_public_path__ + "static/media/logo-bw.9d12d1f5.png";